import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const role = sp.get("role") || "customer";
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post(
          `/auth/google/session?role=${encodeURIComponent(role)}`,
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data.user);
        toast.success("Signed in with Google");
        const target = data.user.role === "tradesperson"
          ? (data.user.subscription_status === "active" ? "/dashboard/trader" : "/onboarding/trader")
          : "/dashboard/customer";
        // Clean hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate(target, { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, role, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" style={{ background: "var(--bg-sand)" }}>
      <Logo size={100} />
      <p className="text-[var(--text-muted)]">Signing you in…</p>
    </div>
  );
}
